import React from 'react'
import LoanHero from '../components/Loan-products/hero'
import PartnerRouting from '../components/Loan-products/partner';
import ProductCTA from '../components/Loan-products/cta';
import PopularLoans from '../components/Home/popular-loans';

export default function LoanProducts() {
  return (
    <main>
      <div className="pt-20">
        <LoanHero />
        {/* <LoanProductsList /> */}
        <PopularLoans />
        <PartnerRouting/>
        <ProductCTA/>
      </div>
    </main>
  );
}
